// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutAuth_wrapper__cFvEM"};